import React, { useState } from 'react';
import axios from 'axios';
import CommonModal from '../../common_jsx/CommonModal'
import config from '../../config.js';

function DataSourceDeleteModal({ savedsource, showDeleteModal, setShowDeleteModal, setConductReload }) {

    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertType, setAlertType] = useState('success');
    const [isDeleted, setIsDeleted] = useState(false); // New state for tracking deletion status
    // State for Loading Animation 
    const [isLoading, setIsLoading] = useState(false);
    // Function for Delete Request
    const HandleSubmit = async (e, savedsource) => {
        e.preventDefault();
        // Start the loading animation
        setIsLoading(true);
        const config_home = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': localStorage.getItem('token')
            },
            data: savedsource
        };
        try {
            const response = await axios.delete(`${config.serviceUrl}/fulfillment-source/delete`, config_home);
            // Set success alert
            setAlertMessage(response.data.message);
            setAlertType('success');
            setShowAlert(true);
            setIsDeleted(true); 
            setConductReload(prevState => !prevState);
        } catch (error) {
            console.error('There was an error!', error);
            // Set error alert
            setAlertMessage(error.message);
            setAlertType('danger');
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    const deleteBody = (
        <>
            {showAlert ? (
                <div className={`px-4 py-3 rounded mb-4 ${
                    alertType === 'success' 
                        ? 'bg-green-100 border border-green-400 text-green-700' 
                        : 'bg-red-100 border border-red-400 text-red-700'
                }`} role="alert">
                    {alertMessage}
                </div>
            ) : (
                <p className="text-gray-900 dark:text-white">Are you sure you want to delete this configuration?</p>
            )}

            <form onSubmit={(e) => HandleSubmit(e, savedsource)}>
                <button type="submit" className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2" disabled={isDeleted}>
                    {isLoading &&
                        <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" role="status">
                            <span className="sr-only"></span>
                        </div>}
                    {isLoading ? ' Working...' : 'Delete'}
                </button>
            </form>
        </>
    )

    const deleteDataSourceContent = {
        heading: "Delete Data Source",
        body: deleteBody,
        isLoading: isLoading
    }


    return (
        <CommonModal
            show={showDeleteModal}
            setShow={setShowDeleteModal}
            modalContent={deleteDataSourceContent}
        />
    )
}

export default DataSourceDeleteModal
